export default __webpack_public_path__ + "static/media/cantileverlogoblack.8c716735.png";